/**
 * pathアニメーション
 */
const pathInit = (element, length) => {
  element.style.strokeDasharray = element.getTotalLength()
  element.style.strokeDashoffset = length ? length : 0
}

/**
 * pathアニメーション
 * Shuffleボタン
 */
export const pathAnimateShuffle = () => {
  let isShuffle = false
  const navigationItemShuffles = document.querySelectorAll('.navigation-item_shuffle')
  const pathAnimateShuffle = (element) => {
    const length = element.getTotalLength()
    gsap
      .timeline({
        onComplete: () => {
          isShuffle = false
        },
      })
      .to(element, {
        duration: 0.5,
        ease: 'power1.out',
        strokeDashoffset: -length,
        onComplete: () => {
          gsap.getProperty(element, 'stroke') === 'rgb(167, 0, 255)'
            ? gsap.set(element, { stroke: 'rgb(128, 255, 157)' })
            : gsap.set(element, { stroke: 'rgb(167, 0, 255)' })
        },
      })
      .to(
        element,
        {
          duration: 0.5,
          ease: 'power1.out',
          strokeDashoffset: 0,
        },
        0.6
      )
  }
  navigationItemShuffles.forEach((navigationItemShuffle) => {
    navigationItemShuffle.addEventListener('mouseenter', () => {
      if (!isShuffle) {
        isShuffle = true
        const navigationItemShufflePathPurple = navigationItemShuffle.querySelector(
          '.navigation-item_shufflePathPurple'
        )
        const navigationItemShufflePathGreen = navigationItemShuffle.querySelector(
          '.navigation-item_shufflePathGreen'
        )
        pathInit(navigationItemShufflePathPurple)
        pathInit(navigationItemShufflePathGreen)
        pathAnimateShuffle(navigationItemShufflePathPurple)
        pathAnimateShuffle(navigationItemShufflePathGreen)
      }
    })
  })
}

/**
 * pathアニメーション
 * header-logo
 * footer-logo
 */
export const pathAnimateLogo = () => {
  const jsLogos = document.querySelectorAll('.js-logo')
  jsLogos.forEach((jsLogo) => {
    const jsLogoPath01 = jsLogo.querySelector('.js-logoPath01')
    const jsLogoPath02 = jsLogo.querySelector('.js-logoPath02')
    const jsLogoPath03 = jsLogo.querySelector('.js-logoPath03')
    const jsLogoPath04 = jsLogo.querySelector('.js-logoPath04')
    const jsLogoPath05 = jsLogo.querySelector('.js-logoPath05')
    const jsLogoPath06 = jsLogo.querySelector('.js-logoPath06')
    const jsLogoPath07 = jsLogo.querySelector('.js-logoPath07')
    const jsLogoPath08 = jsLogo.querySelector('.js-logoPath08')
    pathInit(jsLogoPath01)
    pathInit(jsLogoPath02)
    pathInit(jsLogoPath03)
    pathInit(jsLogoPath04)
    pathInit(jsLogoPath05)
    pathInit(jsLogoPath06)
    pathInit(jsLogoPath07)
    pathInit(jsLogoPath08)
    jsLogo.addEventListener('mouseenter', () => {
      const getTotalLength01 = jsLogoPath01.getTotalLength()
      const getTotalLength02 = jsLogoPath02.getTotalLength()
      const getTotalLength03 = jsLogoPath03.getTotalLength()
      const getTotalLength04 = jsLogoPath04.getTotalLength()
      const getTotalLength05 = jsLogoPath05.getTotalLength()
      const getTotalLength06 = jsLogoPath06.getTotalLength()
      const getTotalLength07 = jsLogoPath07.getTotalLength()
      const getTotalLength08 = jsLogoPath08.getTotalLength()
      gsap
        .timeline()
        .to(
          jsLogoPath01,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: -getTotalLength01,
          },
          0
        )
        .to(
          jsLogoPath02,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: -getTotalLength02,
          },
          0.1
        )
        .to(
          jsLogoPath03,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: -getTotalLength03,
          },
          0.2
        )
        .to(
          jsLogoPath04,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: -getTotalLength04,
          },
          0.3
        )
        .to(
          jsLogoPath05,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: -getTotalLength05,
          },
          0.4
        )
        .to(
          jsLogoPath06,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: -getTotalLength06,
          },
          0.5
        )
        .to(
          jsLogoPath07,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: -getTotalLength07,
          },
          0.6
        )
        .to(
          jsLogoPath08,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: -getTotalLength08,
          },
          0.7
        )
        .to(
          jsLogoPath01,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: 0,
          },
          0.5
        )
        .to(
          jsLogoPath02,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: 0,
          },
          0.6
        )
        .to(
          jsLogoPath03,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: 0,
          },
          0.7
        )
        .to(
          jsLogoPath04,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: 0,
          },
          0.8
        )
        .to(
          jsLogoPath05,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: 0,
          },
          0.9
        )
        .to(
          jsLogoPath06,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: 0,
          },
          1.0
        )
        .to(
          jsLogoPath07,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: 0,
          },
          1.1
        )
        .to(
          jsLogoPath08,
          {
            duration: 0.5,
            ease: 'power2.out',
            strokeDashoffset: 0,
          },
          1.2
        )
    })
  })
}

/**
 * pathアニメーション
 * thumbnail-bg
 */
export const pathAnimateThumbnail = () => {
  gsap.timeline().to(
    '.thumbnail-media',
    {
      duration: 0.3,
      ease: 'expo.out',
      opacity: 1,
    },
    0.1
  )
}
